import { render } from "./Quotas.vue?vue&type=template&id=1010bfc9&scoped=true"
import script from "./Quotas.vue?vue&type=script&lang=js"
export * from "./Quotas.vue?vue&type=script&lang=js"

import "./Quotas.vue?vue&type=style&index=0&id=1010bfc9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1010bfc9"

export default script